<template>
  <v-footer app class="footerpart" inset>
    <v-row>
      <v-col cols="8">
        <span class="text-caption grey--text"
          >© {{ new Date().getFullYear() }} — I Luv
          <a href="https://onseminar.com/" target="_blank">ONSEMINAR</a></span
        >
      </v-col>
      <v-col cols="4" class="version">
        <span class="text-caption grey--text">v{{ appVersion }}</span>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
const APP_VERSION = process.env.APP_VERSION;
export default {
  name: "Footer",
  data: () => ({
    appVersion: APP_VERSION,
    appName: "Onseminar Console - Channel"
  })
};
</script>
<style lang="scss" scoped>
.v-application .footerpart {
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--light.v-footer {
  background-color: #fff;
}
.version {
  text-align: right;
}
</style>
